module.exports = __webpack_public_path__ + "static/pierre.ricadat-9532719610b01094815355ce2f856ee5.png";